// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"d3eaa75f","526":"a1d0c4ac"}[chunkId] + ".chunk.css";
};